// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCashCheckmark = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M2 19V5h20v7h-2V9h-2V7H6v2H4v6h2v2h7v2z" />,
    <path d="M15 12a3 3 0 10-6 0 3 3 0 006 0m8 4.996V14l-5 5-3-3v2.996l3 3z" />
  );
export default SvgIconCashCheckmark;
